<template>
	<div>
		<header class="page-title">
			<h2>Mentions</h2>
			<div class="ml-auto">
				<a href="#" class="btn btn-md btn-success"><i class="fas fa-plus"></i> Add New Mention</a>
			</div>
		</header>

		<div class="grid--nav-horizontal">
			<nav class="nav-horizontal">
				<ul>
					<li :class="[activeTab.name === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs">
						<a @click.prevent="setActiveTabName(tab)">{{ tab.displayName }}</a>
					</li>
				</ul>
			</nav>
			<div class="nav-horizontal-contents">
				<div v-if="activeTab.name === 'general'">
					<table>
					<thead>
						<tr>
							<th>Date</th>
							<th>Site Name</th>
							<th>Article Title</th>
							<th>Quote</th>
							<th class="actions">Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in userMentions.activeTab">
							<td>{{ item.date }}</td>
							<td>{{ item.siteName }}</td>
							<td>{{ item.articleTitle }}</td>
							<td>{{ item.quote }}</td>
							<td>
								<a href="#" class="btn btn-icon btn-primary" title="Edit"><i class="fas fa-fw fa-pencil-alt"></i></a>
								<a href="#" class="btn btn-icon btn-danger" title="Delete"><i class="fas fa-fw fa-trash"></i></a>
							</td>
						</tr>
					</tbody>
				</table>
				</div>

				<div v-for="tab in siteTabs" v-else>
					<table v-if="tab.name === activeTab.name">
						<thead>
							<tr>
								<th>Date</th>
								<th>Site Name</th>
								<th>Article Title</th>
								<th>Quote</th>
								<th class="actions">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Másik</td>
								<td>TheNextWeb.com</td>
								<td>Ut enim ad minim veniam, quis nostrud exercitation</td>
								<td>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
									tempor incididunt ut labore et dolore magna aliqua.
								</td>
								<td>
									<a href="#" class="btn btn-icon btn-primary" title="Edit"><i class="fas fa-fw fa-pencil-alt"></i></a>
									<a href="#" class="btn btn-icon btn-danger" title="Delete"><i class="fas fa-fw fa-trash"></i></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			dataUserMentions: {
				type: Object
			},
		},
		data() {
			return {
				userMentions: this.dataUserMentions,
				tabs: [],
				siteTabs: [],
				activeTab: null
			}
		},
		created() {
			let vm = this;
			vm.tabs.push({
				displayName: 'General',
				name: 'general',
				id: null
			});
			vm.activeTab = this.tabs[0];

			for (let i = 0; i < vm.$availableSites.length; i++) {
				vm.tabs.push({
					displayName: vm.$availableSites[i].name,
					name: vm.$availableSites[i].slug,
					id: vm.$availableSites[i].id
				});
			}

			for (let i = 0; i < vm.$availableSites.length; i++) {
				vm.siteTabs.push({
					displayName: vm.$availableSites[i].name,
					name: vm.$availableSites[i].slug,
					id: vm.$availableSites[i].id
				});
			}
		},
		methods: {
			setActiveTabName: function (tab) {
				this.activeTab = tab;
			}
		}
	}
</script>

<style scoped>

</style>